import { createContext } from 'react';
import { API } from '@shared/types/api';

export const ViewTemplateContext = createContext<API.ViewTemplateFragment | null>(null);
